import { ListItemButton, ListItemText, Skeleton } from '@mui/material';
import * as React from 'react';

import { BaseLeftPanelItemSx, Sizes } from '../../@shared/palette';



const LoadingShimmer = () => {

  return <>
    {[...Array(3).keys()].map((x) => {
      return <ListItemButton key={x} sx={{ paddingTop: "10px", paddingBottom: "10px", ...BaseLeftPanelItemSx }}>
        <ListItemText sx={{
          position: "relative"
        }}>
          <Skeleton variant="text" sx={{ fontSize: Sizes.textPrimary }} />
          <Skeleton variant="text" sx={{ fontSize: Sizes.textSecondary }} />
        </ListItemText>
      </ListItemButton>
    })}
  </>

}




export default LoadingShimmer;

